import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { Link } from 'react-router-dom'
import {
    avatar1,
    avatar2,
    avatar3,
    avatar6,
    avatar7,
} from '../../assets/images'
import {
    IconAlertTriangleFilled,
} from '@tabler/icons-react'

export default function Activity() {

    return (
        <>
            <Breadcrumb title="Activites" path="Activites" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='p-20 border-l border-success relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-success after:rounded-full'>
                    <p className='text-success mb-10'>
                        Just Now
                    </p>
                    <p className='text-[16px]/[19.2px] font-medium mb-10'>
                        Add New Task
                    </p>
                    <p className='text-text-secondary mb-15'>
                        Web by far While that's mock-ups and this is politics Lorem card.
                    </p>
                    <div className='flex items-center gap-10'>
                        <p className='text-text-secondary'>
                            Team :
                        </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
                <div className='p-20 border-l border-warning relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-warning after:rounded-full'>
                    <p className='text-warning mb-10'>
                        6 mins ago
                    </p>
                    <p className='text-[16px]/[19.2px] font-medium mb-10'>
                        Lucid Admin Code Upload on Github
                    </p>
                    <p className='mb-15'>
                        By : <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Jessica Doe</Link>
                    </p>
                    <p className='text-text-secondary mb-15'>
                        web by far While that's mock-ups and this is politics, are they really so different? I think the only card she has is the Lorem card.
                    </p>
                    <p className='md:p-20 p-15 text-black flex gap-10 border border-yellow rounded-lg bg-yellow-50'>
                        <IconAlertTriangleFilled className='w-[18px] h-[18px] min-w-[18px] min-h-[18px]' />
                        I am getting an error when trying to push to github. It will not let me push
                    </p>
                </div>
                <div className='p-20 border-l border-danger relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-danger after:rounded-full'>
                    <p className='text-danger mb-10'>
                        15 mins ago
                    </p>
                    <p className='text-[16px]/[19.2px] font-medium mb-10'>
                        Assigning a project team
                    </p>
                    <p className='mb-15'>
                        Team Leader : <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Jessica Doe</Link>
                    </p>
                    <p className='text-text-secondary mb-15'>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    </p>
                    <div className='flex items-center gap-10'>
                        <p className='text-text-secondary'>
                            Team :
                        </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
                <div className='p-20 border-l border-danger relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-danger after:rounded-full'>
                    <p className='text-danger mb-10'>
                        1 day ago
                    </p>
                    <p className='text-[16px]/[19.2px] font-medium mb-10'>
                        Send email to all Employee salary slip
                    </p>
                    <p className='text-text-secondary'>
                        It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout
                    </p>
                </div>
                <div className='p-20 border-l border-text-primary relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-text-primary after:rounded-full'>
                    <p className='text-text-primary mb-10'>
                        16 June, 2021
                    </p>
                    <p className='text-[16px]/[19.2px] font-medium mb-10'>
                        Id-Ul-Fitr Function in Office
                    </p>
                    <p className=''>
                        <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Katherine Lumaad</Link> Oakland, CA
                    </p>
                </div>
            </div>
        </>
    )
}
